//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sort } from 'timsort';
import { mapGetters } from 'vuex';
import { PALETTE_COLOURS } from '@/store/types/getters';
import { COLOURS } from '@/store/types/namespaces';
import { importPlotly } from './Plotly';
import BaseChart from './baseChart';

export default {
  name: 'DpPieChart',
  mixins: [BaseChart],
  props: {
    valuesToShow: {
      type: Number,
      default: () => 5,
    },
    chartParams: { type: Object, required: true },
  },
  data() {
    return {
      showNoDataMessage: false,
    };
  },
  computed: {
    ...mapGetters(COLOURS, [PALETTE_COLOURS]),
  },
  watch: {
    chartParams: {
      handler() {
        this.run();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.run();
  },
  methods: {
    async run() {
      const { data } = this.chartParams;

      if (!data || data.length === 0) {
        this.showNoDataMessage = true;
        return;
      }
      this.showNoDataMessage = false;

      // Sort the values descending
      sort(data, (a, b) => {
        const aVal = a.value;
        const bVal = b.value;
        return bVal - aVal;
      });

      const values = [];
      const labels = [];

      // Construct the trace data arrays
      let currentCount = 0;
      data.forEach((d) => {
        if (currentCount <= this.valuesToShow) {
          values[currentCount] = d.value;
          labels[currentCount] = d.label;
          currentCount += 1;
        } else {
          values[this.valuesToShow] += d.value;
          labels[this.valuesToShow] = 'Other';
        }
      });

      // Setup the basic pie chart
      const trace = [{
        values,
        labels,
        type: 'pie',
        pull: 0,
        marker: {
          colors: this[PALETTE_COLOURS].chart,
        },
        textinfo: 'percent',
        textposition: 'inside',
        textfont: {
          color: '#FFF',
        },
      }];

      const layout = {
        margin: {
          l: 0, b: 10, r: 0, t: 10,
        },
        font: {
          family: 'Proxima Nova, Arial',
        },
        plot_bgcolor: 'transparent',
        paper_bgcolor: 'transparent',
        showlegend: true,
        legend: {
          orientation: 'v',
          // traceorder: 'normal',
          x: 0,
          y: -0.75,
          font: {
            color: this[PALETTE_COLOURS].dark,
          },
        },
      };

      const { Plotly } = await importPlotly();

      if (!this.$refs.element) {
        return;
      }

      Plotly.newPlot(this.$refs.element, trace, layout, { showLink: false }).then(() => {
        this.canResize = true;
        this.resize();
      });
    },
  },
};
